import React, { useState } from 'react';
import caitviKabedon from '../assets/Q8/caitvi_kabedon.gif';
import viWink from '../assets/Q8/vi_wink.gif';
import caitviSweet from '../assets/Q8/caitvi_sweet.gif';


function Q8({ question = 8, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [step, setStep] = useState(0); // 0 = initial, 1 = first click, 2 = second click

  const handleClick = () => {
    if (step === 0) {
      setStep(1);
    } else if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      onNavigate?.('q9');
    }
  };

  const titleText = step === 0 ? "You're hot cupcake ~" : step === 1 ? <>The <br/>sweetest</> : <>Fucking <br/>Fantastic</>;
  const buttonText = step === 0 ? '* ASDFGKJL *' : step === 1 ? '* ASDASDJLASJDLKAJDS *' : '* AKSJDHKASHDKJASHDKAHSDKASHKDHAKSHDFKASHDFKASHF *';
  const gifSrc = step === 0 ? caitviKabedon : step === 1 ? caitviSweet : viWink;

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a brave title</span>
        <h1>Project Valen</h1>
        <p>* Deep breath *</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center q8__center">
      <span className="secretpin__title q2__greeting q8__greeting">
        {titleText}
      </span>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q2__wave-button q8__button"
        onClick={handleClick}
      >
        {buttonText}
      </button>
      <img src={gifSrc} alt="" className={`q2__gif q8__gif ${step === 0 ? 'q8__gif--second' : ''}`} />
    </div>
  </div>
  );
}

export default Q8;
